import { getAssetUrl } from '@lighthouse/assets'
import { BlockType } from '@lighthouse/core'
import { BlockThumbImageMap } from '@lighthouse/shared'

import type { BlockTree, BlockTreeItem } from '../type'
import { BlockKind } from '../type'

export const blockText: BlockTreeItem = {
    name: '文本',
    icon: '',
    describeImage: BlockThumbImageMap['text'],
    color: '#667085',
    backGroundColor: 'rgba(102, 112, 133, 0.10)',
    type: BlockType.text
}

const blockHighlight: BlockTreeItem = {
    type: 'highlight',
    name: '高亮文本',
    icon: 'Widget',
    describeImage: getAssetUrl('blocks', 'highlight_text.svg'),
    backGroundColor: 'var(--color-gray-50)',
    color: '#667085'
}

const blockCombination: BlockTreeItem = {
    type: 'combinationTitle',
    name: '组合标题',
    icon: 'Widget',
    describeImage: getAssetUrl('blocks', 'preset_title.svg'),
    backGroundColor: 'var(--color-gray-50)',
    color: '#667085'
}

const blockIcon: BlockTreeItem = {
    name: '图标',
    icon: 'IconBlock',
    describeImage: BlockThumbImageMap['icon'],
    color: '#667085',
    backGroundColor: 'rgba(102, 112, 133, 0.10)',
    type: BlockType.icon
}

const blockUserCenter: BlockTreeItem = {
    name: '个人中心',
    icon: 'PersonalCenterBlock',
    describeImage: BlockThumbImageMap['userCenter'],
    color: '#667085',
    backGroundColor: 'rgba(102, 112, 133, 0.10)',
    type: BlockType.userCenter
}

const blockFloat: BlockTreeItem = {
    name: '弹出窗口',
    icon: '',
    describeImage: BlockThumbImageMap['floatBox'],
    color: '#667085',
    backGroundColor: 'rgba(102, 112, 133, 0.10)',
    type: BlockType.floatBox
}

export const allText: BlockTree = {
    id: BlockKind.text,
    name: '通用',
    items: [blockText, blockHighlight, blockCombination, blockIcon, blockUserCenter]
}
